module.exports = __webpack_public_path__ + "img/started.0df1bdaf.gif";